var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "role": "search",
      "action": "."
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.submit($event);
      }
    }
  }, [_c('InputText', {
    ref: "input",
    attrs: {
      "btn": "go",
      "aria-label": "Search Terms",
      "autocomplete": "off",
      "type": "search",
      "placeholder": "Enter text or page..."
    },
    on: {
      "reset": _vm.reset
    },
    model: {
      value: _vm.formData.terms,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "terms", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.terms"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }